export const navLinks = [
  {
    name: "Why this app?",
    url: "/#why",
  },
  {
    name: "Features",
    url: "/#features",
  },
  {
    name: "Plan & Pricing",
    url: "/#plans",
  },
  {
    name: "FAQ",
    url: "/#faq",
  },
  {
    name: "Contact",
    url: "/#contact",
  },
];
